module.exports = __webpack_public_path__ + "static/media/invitation.f79947d6.png";